export var StreamType;
(function (StreamType) {
    StreamType["SMOOTH_STREAMING"] = "SMOOTH_STREAMING";
    StreamType["HLS"] = "HLS";
    StreamType["DASH"] = "DASH";
    StreamType["DASH_WIDEVINE"] = "DASH_WIDEVINE";
    StreamType["DASH_PLAYREADY"] = "DASH_PLAYREADY";
    StreamType["HLS_FAIRPLAY"] = "HLS_FAIRPLAY";
    StreamType["SMOOTH_STREAMING_PLAYREADY"] = "SMOOTH_STREAMING_PLAYREADY";
    StreamType["UNKNOWN"] = "UNKNOWN";
})(StreamType || (StreamType = {}));
